const CommonProperties = {
    id: 'name',
    value: 'value',
    margin: {
        top: 20,
        right: 20,
        bottom: 100,
        left: 20
    },
}
const SunburstContainer = {
    height: 680
}

export {CommonProperties, SunburstContainer}